import locale from "localization/en";

export const lubricantSalesColumn = [
  { key: "productCategory", text: locale.productCategory },
  { key: "itemCode", text: locale.itemCode },
  { key: "product", text: locale.product },
  { key: "variant", text: locale.variant },
  { key: "unitPrice", text: locale.unitPrice, width: "150px" },
  { key: "quantitySold", text: locale.quantitySold },
  { key: "amount", text: locale.amount, width: "150px" },
  { key: "discounts", text: `${locale.discount}/${locale.premium}`, width: "150px" },
  { key: "finalAmount", text: locale.finalAmount, width: "150px" },
];
